import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "ofs",
  style: {"height":"400px"}
}
const _hoisted_3 = {
  key: 0,
  class: "mc innerEditAppointmentContent"
}
const _hoisted_4 = { class: "fs20 ls1 mc centered fw600" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "fl w50" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl fs13 fw600 mt5 mr30",
  style: {"width":"150px"}
}, "終日無視   ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl fs13 fw600 mt5 mr30",
  style: {"width":"150px"}
}, " 特定のイベントを可能日時に反転    ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600" }, "有効なイベントが終日予定の場合の可能時間:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "fs12" }, "5分刻みで入力してください。", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fl mt8" }, "~", -1)
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl fs13 fw600 mt5 mr30",
  style: {"width":"150px"}
}, [
  /*#__PURE__*/_createTextVNode(" 特定のイベントを無視    "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("  ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = { class: "fl w50" }
const _hoisted_24 = {
  key: 0,
  class: "mt30"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "fl fs13 fw600 mt5 mr30",
  style: {"width":"150px"}
}, "確定時イベントを登録   ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = {
  class: "w100 posAb",
  style: {"bottom":"0","left":"0"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "fs16 fw400" }, "保存", -1)
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_AvailableScheduleSettings = _resolveComponent("AvailableScheduleSettings")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "EditCalendarTagModal",
    "content-class": "rad10 pad15 with_white_bg ofs shadowContent modalNormal noscroll posFi",
    onBeforeOpen: _ctx.openModal,
    onBeforeClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("a", {
        class: "dismiss",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissModal && _ctx.dismissModal(...args)))
      }, [
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
          width: "50",
          height: "50"
        }, null, 8, _hoisted_1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.ctag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.getTitle), 1),
              _createElementVNode("p", {
                class: "mt8 fw600",
                innerHTML: _ctx.getDescription
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(`w90 posRe rad20 pad20 ${_ctx.isActive ? `` : `yellowBg`}`)
                }, [
                  (_ctx.cm.edittingCtag)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Switcher, {
                        key: 0,
                        value: "type[is_active]",
                        name: "設定の有効",
                        checked: _ctx.isActive,
                        display: "true",
                        class: "checkUsingCal fr posAb",
                        style: {"transform":"scale(0.5)"},
                        onSelect: _ctx.changeActive
                      }, null, 8, ["checked", "onSelect"])), [
                        [_directive_tooltip, `設定を${_ctx.isActive ? `無効` : `有効`}にします`]
                      ])
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(`mt10 ${_ctx.isActive ? `` : `op4`}`)
                  }, [
                    _hoisted_7,
                    _createVNode(_component_Switcher, {
                      value: "type[ignore]",
                      name: "終日無視",
                      checked: _ctx.ctag.ignore_allday,
                      disabled: !_ctx.isActive,
                      display: "true",
                      class: "checkUsingCal fl",
                      onSelect: _ctx.changeIgnoreAllday
                    }, null, 8, ["checked", "disabled", "onSelect"])
                  ], 2),
                  _hoisted_8,
                  _createElementVNode("div", {
                    class: _normalizeClass(`mt10 ${_ctx.isActive ? `` : `op4`}`)
                  }, [
                    _hoisted_9,
                    _createVNode(_component_Switcher, {
                      value: "type[available]",
                      name: "カレンダー反転モード",
                      checked: _ctx.ctag.can_use_available_event_keyword,
                      display: "true",
                      disabled: !_ctx.isActive,
                      class: "checkUsingCal fl",
                      onSelect: _ctx.changeAvailableEvent
                    }, null, 8, ["checked", "disabled", "onSelect"])
                  ], 2),
                  _hoisted_10,
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_MdTextfieldTag, {
                      name: "可能日時に反転するキーワードを設定",
                      fieldStyle: "min-width:250px;max-width:250px;",
                      style: {"height":"56px","min-width":"250px"},
                      class: "fl fs16",
                      type: `text`,
                      value: _ctx.ctag.available_event_keyword,
                      onInputValue: _ctx.inputAvailableKeyword
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _createElementVNode("input", {
                      type: "time",
                      placeholder: "開始時刻",
                      class: "alldayStart mt5 w100 fl",
                      style: {"height":"35px","width":"98px"},
                      value: `${String(_ctx.ctag.available_event_allday_start_hour || `00`).padStart(2, `0`)}:${String(
                                    _ctx.ctag.available_event_allday_start_min || `00`
                                ).padStart(2, `0`)}`,
                      step: "300",
                      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inputTimeAlldayStart && _ctx.inputTimeAlldayStart(...args)))
                    }, null, 40, _hoisted_15),
                    _hoisted_16,
                    _createElementVNode("input", {
                      type: "time",
                      placeholder: "終了時刻",
                      class: "alldayEnd mt5 w100 fl",
                      style: {"height":"35px","width":"98px"},
                      value: `${String(_ctx.ctag.available_event_allday_end_hour || `00`).padStart(2, `0`)}:${String(
                                    _ctx.ctag.available_event_allday_end_min || `00`
                                ).padStart(2, `0`)}`,
                      step: "300",
                      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputTimeAlldayEnd && _ctx.inputTimeAlldayEnd(...args)))
                    }, null, 40, _hoisted_17)
                  ], 512), [
                    [_vShow, _ctx.availableEvent]
                  ]),
                  _hoisted_18,
                  _createElementVNode("div", {
                    class: _normalizeClass(`mt40 ${_ctx.isActive ? `` : `op4`}`)
                  }, [
                    _hoisted_19,
                    _createVNode(_component_Switcher, {
                      value: "type[ignore]",
                      name: "無視設定",
                      checked: _ctx.ctag.can_use_ignore_event_keyword,
                      display: "true",
                      disabled: !_ctx.isActive,
                      class: "checkUsingCal fl",
                      onSelect: _ctx.changeIgnoreEvent
                    }, null, 8, ["checked", "disabled", "onSelect"])
                  ], 2),
                  _hoisted_20,
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_MdTextfieldTag, {
                      name: "無視するキーワードを設定",
                      fieldStyle: "min-width:250px;max-width:250px;",
                      style: {"height":"56px","min-width":"250px"},
                      class: "fl fs16",
                      type: `text`,
                      value: _ctx.ctag.ignore_event_keyword,
                      onInputValue: _ctx.inputIgnoreKeyword
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_21
                  ], 512), [
                    [_vShow, _ctx.ignoreEvent]
                  ]),
                  _hoisted_22
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_ctx.cm.edittingCtag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_Switcher, {
                        value: "type[can_register_calendar]",
                        name: "確定時イベントを登録",
                        checked: _ctx.ctag.can_register_calendar,
                        display: "true",
                        class: "checkUsingCal fl",
                        onSelect: _ctx.changeCanRegisterCalendar
                      }, null, 8, ["checked", "onSelect"])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_26,
                (_ctx.cm.edittingAstag)
                  ? (_openBlock(), _createBlock(_component_AvailableScheduleSettings, {
                      key: 1,
                      class: "mt30",
                      astag: _ctx.ctag,
                      onUpdateAstag: _ctx.updateAstag
                    }, null, 8, ["astag", "onUpdateAstag"]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_27,
              _hoisted_28,
              _hoisted_29
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("section", {
          class: "fs16 pointer centered w100 skyblueBg",
          style: {"line-height":"50px","height":"50px"},
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveCtag && _ctx.saveCtag(...args)))
        }, _hoisted_32)
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen", "onBeforeClose"]))
}